import { avaliahubApiUrl } from '../global';

/**
 * The avaliahub-api URL is optional: without it the Legado section is not
 * offered at all (no tab, no routes). CRA inlines the variable at build time.
 */
export const legacyApiUrl = avaliahubApiUrl;

export const isLegacyEnabled = legacyApiUrl !== '';
